export interface DisplayOptions {
  showChartBar?: boolean;
  showChartLine?: boolean;
  showChartArea?: boolean;
  showChartPie?: boolean;
}

export enum ChartType {
  BarChart = 'bc-bar-chart',
  LineChart = 'bc-line-chart',
  DoughnutChart = 'bc-doughnut-chart',
  PieChart = 'bc-pie-chart',
  // Add more if neccesary
}
